{
  "el": {
    "session": {
      "error_internalserver": {
        "goback": "Επιστροφή",
        "subtitle": "Ωχ, φαίνεται πως προέκυψε ένα απροσδόκητο σφάλμα.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Επιστροφή",
        "subtitle": "Λυπούμαστε, η σελίδα που αναζητάς δεν βρέθηκε.",
        "title": "404"
      },
      "expired": {
        "text": "Η σύνδεσή σου έληξε λόγω αδράνειας. Για λόγους ασφαλείας, χρειάζεται να συνδεθείς ξανά. \n\nΠάτησε OK για να μεταφερθείς στην οθόνη σύνδεσης.",
        "title": "Λήξη σύνδεσης"
      },
      "logout_impersonate": {
        "text": "Πραγματοποιήθηκε αποσύνδεση κατά τη διάρκεια υπόδυσης.",
        "title": "Η υπόδυση διακόπηκε"
      },
      "noaccess": {
        "text": "Ίσως επηρεάζεσαι από την πιο πρόσφατη <b>ενημέρωσή</b> μας: <p></p> <ul> <li>&nbsp;</li> <li><b>Τα μέλη της ομάδας και οι συνεργάτες</b> έχουν πλέον πρόσβαση (και σύνδεση) μέσω <b>ziggu.app</b> (αντί για <i>%company%</i>.ziggu.app)</li> <li>&nbsp;</li> <li><b>Οι πελάτες</b> δεν επηρεάζονται και μπορούν να συνεχίσουν να έχουν πρόσβαση στην πλατφόρμα μέσω <b><i>%company%</i>.ziggu.app</b> </ul> <p>&nbsp;</p> <p>Πατώντας OK θα μεταφερθείς στην κατάλληλη σελίδα.</p> <p>Αν συνεχίσεις να αντιμετωπίζεις προβλήματα, επικοινώνησε μαζί μας.</p>",
        "title": "Ωχ.. φαίνεται πως δεν έχεις (πλέον) πρόσβαση σε αυτή τη σελίδα."
      }
    }
  }
}
